import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumRoundedWithoutGroupTotal, sumWithoutGroupTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';

export const totalRowConditionalFormatting = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    // eslint-disable-next-line dot-notation, no-plusplus
    for (let i = 0; i < rowInfo.row['handler'].length; i++) {
      // eslint-disable-next-line dot-notation
      if (rowInfo.row['handler'][i] === 'Total') {
        className = 'non-clickable-link';
      }
    }
  }
  return {
    className,
  };
};

export function getCarrierPerformanceTabNavigationProps(rowInfo, index) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.id,
    // eslint-disable-next-line max-len
    mainReportId: ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.id,
    requestParams: {
      carrier: rowInfo.row['registeredCarrier'], // eslint-disable-line
      mrdLocation: rowInfo.row['handler'][index] === 'Total' ? rowInfo.row['mrdLocation'][index] : rowInfo.row['mrdLocation'][0], // eslint-disable-line
      handler: rowInfo.row['handler'][index], // eslint-disable-line
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data, reqParams) => {
  const {
    MultilineColumn,
    MultilineNumberColumn,
    MultilinePercentageColumn,
    MultilineNumberNavigationWithFooterColumn,
    NonZeroNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new MultilineColumn('Registered carrier', 'registeredCarrier').withTotalHeader('', 'bg-total-grey'),
        new MultilineColumn('MRD location', 'mrdLocation').withTotalHeader('', 'bg-total-grey'),
        new MultilineColumn('Handler', 'handler').withTotalHeader('Total', 'bg-total-grey'),
        new MultilineNumberNavigationWithFooterColumn(new NonZeroNumberColumn('Units', 'units').withGetProps(totalRowConditionalFormatting).withTotalHeader(sumWithoutGroupTotal, 'bg-total-grey'), getCarrierPerformanceTabNavigationProps),
        new MultilineNumberColumn('Registered receptacles', 'registeredReceptacles').withTotalHeader(sumWithoutGroupTotal, 'bg-total-grey'),
        new MultilineNumberColumn('Attributed receptacles', 'attributedReceptacles').withTotalHeader(sumWithoutGroupTotal, 'bg-total-grey'),
        new MultilineNumberColumn('Weight (kg) reg. rcpts', 'weightRegisteredReceptacles').withTotalHeader(sumRoundedWithoutGroupTotal, 'bg-total-grey'),
        new MultilineNumberColumn('Weight (kg) attr. rcpts', 'weightAttributedReceptacles').withTotalHeader(sumRoundedWithoutGroupTotal, 'bg-total-grey'),
        new MultilinePercentageColumn('% Attr. rcpts', 'pctAttributedReceptacles').withTotalHeader(totalRowRatio(['attributedReceptacles', 'registeredReceptacles']), 'bg-total-grey'),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.id,
        // eslint-disable-next-line max-len
        mainReportId: ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.id,
        requestParams: {
          isTotal: true,
          carrier: '*',
          mrdLocation: reqParams.mrdLocation,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
